import "./App.css";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { NotificationContext } from "./Contexts/NotificationContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PublicRoute from "./Components/PublicRoute";
import ProtectedRoute from "./Components/ProtectedRoute";
import Navbar from "./Components/Navbar";
import Article from "./pages/Article";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Newsfeed from "./pages/User/Newsfeed";
import Networks from "./pages/User/Networks";
import Profile from "./pages/User/Profile";
import Jobs from "./pages/User/Jobs";
import Jobcollections from "./pages/User/Jobcollections";
import Messaging from "./pages/User/Messaging";
import Notifications from "./pages/User/Notifications";
import ProfileUser from "./pages/User/ProfileUser";
import Error from "./pages/Error";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import Onboardingstep1 from "./pages/Onboardingstep1";
import Onboardingstep2 from "./pages/Onboardingstep2";
import Onboardingstep3 from "./pages/Onboardingstep3";
import Onboardingstep4 from "./pages/Onboardingstep4";
import Onboardingstep5 from "./pages/Onboardingstep5";
import Onboardingstep6 from "./pages/Onboardingstep6";
import Onboardingstep7 from "./pages/Onboardingstep7";
import Onboardingstep8 from "./pages/Onboardingstep8";
import Onboardingstep9 from "./pages/Onboardingstep9";
import Student from "./pages/Student";
import EditExperience from "./pages/Edit/EditExperience";
import EditEducation from "./pages/Edit/EditEducation";
import EditSkill from "./pages/Edit/EditSkill";
import ManageInvitations from "./pages/User/ManageInvitations";
import EditPost from "./pages/Edit/EditPost";
import Group from "./pages/Group/Group";
import Groupdetail from "./pages/Group/Groupdetail";
import GroupManage from "./pages/Group/GroupManage";
import Events from "./pages/Event/Events";
import AnalyticsDashboard from "./pages/Edit/Analytics";
import EventList from "./pages/Event/EventList";
import EventDetails from "./pages/Event/EventDetails";
import LinkedInEditor from "./pages/Article/Articlee";
import ConnectionsList from "./pages/Netwrok/Connections";
import FollowersFollowing from "./pages/Netwrok/Followers&Following";
import DiscoverGroups from "./pages/Group/Discover";
import CreateLinkedInPage from "./pages/Business/Company/CreateLinkedInPage/CreateLinkedInPage";
import CreateCompanyPage from "./pages/Business/Company/CreateCompanyPage/CreateCompanyPage";
import CompanyDashboard from "./pages/Business/Company/Dashboard/Dashboard";
import CompanyPagePosts from "./pages/Business/Company/PagePosts/PagePosts";
import CompanyInbox from "./pages/Business/Company/Inbox/Inbox";
import SavedPost from "./pages/SavedItems/SavedPost";
import DetailedSavePost from "./pages/SavedItems/DetailedSavePost";
import CompanyProduct from "./pages/Business/Company/Products/Product";
import CompanyProductDescription from "./pages/Business/Company/Products/ProductDescription";
import axios from "axios";
import BaseUrl from "./Components/BaseUrl";
import Cookies from "js-cookie";

function App() {
  const [mcount, setMcount] = useState(0);
  const [ncount, setNcount] = useState(0);
  const [userData, setUserData] = useState({});
  const { setMessageCount, setNotificationCount } =
    useContext(NotificationContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showNotification = useCallback(
    (message, variant = "info") => {
      enqueueSnackbar(message, {
        variant,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        autoHideDuration: 5000,
        action: (key) => (
          <IconButton
            size="small"
            color="inherit"
            onClick={() => closeSnackbar(key)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        ),
      });
    },
    [enqueueSnackbar, closeSnackbar]
  );

  useEffect(() => {
    let interval;
    const pollUpdates = async () => {
      const token = Cookies.get("token");
      try {
        const [notificationRes, messageRes] = await Promise.all([
          axios.get(BaseUrl + "notificationCount", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(BaseUrl + "messageCount", {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        if (notificationRes.data.status === 200) {
          const newCount = notificationRes.data.data;

          setNotificationCount(newCount);

          setNcount((prevCount) => {
            if (newCount > prevCount) {
              const diff = newCount - prevCount;
              showNotification(
                `🔔 You have ${diff} new notification${diff > 1 ? "s" : ""}`,
                "info"
              );
            }
            return newCount;
          });
        }
        if (messageRes.data.status === 200) {
          const newCount = messageRes.data.data;
          setMessageCount(newCount);

          setMcount((prevCount) => {
            if (newCount > prevCount) {
              const diff = newCount - prevCount;
              showNotification(
                `✉️ You have ${diff} new message${diff > 1 ? "s" : ""}`,
                "info"
              );
            }
            return newCount;
          });
        }
      } catch (error) {
        console.error("Polling error:", error);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        pollUpdates();
        interval = setInterval(pollUpdates, 5000);
      } else {
        clearInterval(interval);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    pollUpdates();
    interval = setInterval(pollUpdates, 5000);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [setMessageCount, setNotificationCount]);

  const getUserDetails = async () => {
    try {
      const response = await axios.get(BaseUrl + `userDetails`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setUserData(response.data.data);
    } catch (error) {
      console.error("Error fetching user details:", error);
      return null;
    }
  };
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      getUserDetails();
    } else {
      setUserData({});
    }
  }, [Cookies.get("token")]);
  return (
    <>
      <Navbar user={userData} />
      <ToastContainer
        position="top-end"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        pauseOnFocusLoss={false}
        draggable
        toastClassName="custom-toast"
      />
      {/* <Routes>
        <Route path="*" element={<Error />} />
        <Route path="/" element={<Article />} />
        <Route path="/user/login" element={<Login />} />
        <Route path="/user/forgot-password" element={<ForgetPassword />} />
        <Route path="/user/reset-password" element={<ResetPassword />} />
        <Route path="/user/register" element={<Register />} />
        <Route path="/user/onboarding/step1" element={<Onboardingstep1 />} />
        <Route path="/user/onboarding/step2" element={<Onboardingstep2 />} />
        <Route path="/user/onboarding/step3" element={<Onboardingstep3 />} />
        <Route path="/user/onboarding/student" element={<Student />} />
        <Route path="/user/onboarding/step4" element={<Onboardingstep4 />} />
        <Route path="/user/onboarding/step5" element={<Onboardingstep5 />} />
        <Route path="/user/onboarding/step6" element={<Onboardingstep6 />} />
        <Route path="/user/onboarding/step7" element={<Onboardingstep7 />} />
        <Route path="/user/onboarding/step8" element={<Onboardingstep8 />} />
        <Route path="/user/onboarding/step9" element={<Onboardingstep9 />} />
        <Route path="/user/home" element={<Newsfeed />} />
        <Route path="/user/networks" element={<Networks />} />
        <Route
          path="/user/networks/connections"
          element={<ConnectionsList />}
        />
        <Route
          path="/user/networks/following-followers"
          element={<FollowersFollowing />}
        />
        <Route path="/user/manageinvitation" element={<ManageInvitations />} />
        <Route path="/user/profile/:slug" element={<Profile />} />
        <Route path="/user/jobs" element={<Jobs />} />
        <Route path="/user/jobcollections" element={<Jobcollections />} />
        <Route path="/user/messaging" element={<Messaging />} />
        <Route path="/user/messaging/:user_slug?" element={<Messaging />} />
        <Route path="/user/notifications" element={<Notifications />} />
        <Route path="/user/userprofile" element={<ProfileUser />} />
        <Route path="/user/editexperience" element={<EditExperience />} />
        <Route path="/user/editeducation" element={<EditEducation />} />
        <Route path="/user/editskill" element={<EditSkill />} />
        <Route path="/user/editpost" element={<EditPost />} />
        <Route path="/user/analytics" element={<AnalyticsDashboard />} />

        //  Group section routes 
        <Route path="/groups/discover" element={<DiscoverGroups />} />
        <Route path="/groups" element={<Group />} />
        <Route path="/groups/:slug" element={<Groupdetail />} />
        <Route
          path="/groups/managegroup/:slug/:tabValue?/:menuItem?"
          element={<GroupManage />}
        />
        <Route
          path="/groups/managegroup/:tabValue/:menuItem"
          element={<GroupManage />}
        />
        <Route path="/groups/managegroup/:tabValue" element={<GroupManage />} />

        // Event section routes 
        <Route path="/events" element={<Events />} />
        <Route path="/events/allevents" element={<EventList />} />
        <Route path="/events/:slug" element={<EventDetails />} />

        //  Article section routes 
        <Route path="/article" element={<LinkedInEditor />} />

        //  Saved section routes 
        <Route path="/my-items/saved-post" element={<SavedPost />} />
        <Route path="/saved-post/:type/:id" element={<DetailedSavePost />} />

        //  Business section routes 
        <Route
          path="/company/setup-page/new"
          element={<CreateLinkedInPage />}
        />
        <Route
          path="/company/setup-page/create-company-page"
          element={<CreateCompanyPage />}
        />
        <Route path="/company/dashboard" element={<CompanyDashboard />} />
        <Route path="/company/page-posts" element={<CompanyPagePosts />} />
        <Route path="/company/inbox" element={<CompanyInbox />} />
        <Route path="/company/product-listing" element={<CompanyProduct />} />
        <Route
          path="/company/product-description/car-wash-software"
          element={<CompanyProductDescription />}
        />
      </Routes> */}
      // In App.js, update the Routes section
      <Routes>
        {/* Public routes (accessible without token) */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Article />} />
          <Route path="/user/login" element={<Login />} />
          <Route path="/user/forgot-password" element={<ForgetPassword />} />
          <Route path="/user/reset-password" element={<ResetPassword />} />
          <Route path="/user/register" element={<Register />} />
        </Route>

        {/* Onboarding routes (should be protected but with special handling) */}
        <Route element={<ProtectedRoute />}>
          <Route path="/user/onboarding/step1" element={<Onboardingstep1 />} />
          <Route path="/user/onboarding/step2" element={<Onboardingstep2 />} />
          <Route path="/user/onboarding/step3" element={<Onboardingstep3 />} />
          <Route path="/user/onboarding/student" element={<Student />} />
          <Route path="/user/onboarding/step4" element={<Onboardingstep4 />} />
          <Route path="/user/onboarding/step5" element={<Onboardingstep5 />} />
          <Route path="/user/onboarding/step6" element={<Onboardingstep6 />} />
          <Route path="/user/onboarding/step7" element={<Onboardingstep7 />} />
          <Route path="/user/onboarding/step8" element={<Onboardingstep8 />} />
          <Route path="/user/onboarding/step9" element={<Onboardingstep9 />} />
        </Route>

        {/* Protected routes (require token) */}
        <Route element={<ProtectedRoute />}>
          <Route path="/user/home" element={<Newsfeed />} />
          <Route path="/user/networks" element={<Networks />} />
          <Route
            path="/user/networks/connections"
            element={<ConnectionsList />}
          />
          <Route
            path="/user/networks/following-followers"
            element={<FollowersFollowing />}
          />
          <Route
            path="/user/networks/manageinvitation"
            element={<ManageInvitations />}
          />
          <Route path="/user/profile/:slug" element={<Profile />} />
          <Route path="/user/jobs" element={<Jobs />} />
          <Route path="/user/jobcollections" element={<Jobcollections />} />
          <Route path="/user/messaging" element={<Messaging />} />
          <Route path="/user/messaging/:user_slug?" element={<Messaging />} />
          <Route path="/user/notifications" element={<Notifications />} />
          <Route path="/user/userprofile" element={<ProfileUser />} />
          <Route path="/user/editexperience" element={<EditExperience />} />
          <Route path="/user/editeducation" element={<EditEducation />} />
          <Route path="/user/editskill" element={<EditSkill />} />
          <Route path="/user/editpost" element={<EditPost />} />
          <Route path="/user/analytics" element={<AnalyticsDashboard />} />

          {/* Group section routes */}
          <Route path="/groups/discover" element={<DiscoverGroups />} />
          <Route path="/groups" element={<Group />} />
          <Route path="/groups/:slug" element={<Groupdetail />} />
          <Route
            path="/groups/managegroup/:slug/:tabValue?/:menuItem?"
            element={<GroupManage />}
          />
          <Route
            path="/groups/managegroup/:tabValue/:menuItem"
            element={<GroupManage />}
          />
          <Route
            path="/groups/managegroup/:tabValue"
            element={<GroupManage />}
          />

          {/* Event section routes */}
          <Route path="/events" element={<Events />} />
          <Route path="/events/allevents" element={<EventList />} />
          <Route path="/events/:slug" element={<EventDetails />} />

          {/* Article section routes */}
          <Route path="/article" element={<LinkedInEditor />} />

          {/* Saved section routes */}
          <Route path="/my-items/saved-post" element={<SavedPost />} />
          <Route path="/saved-post/:type/:id" element={<DetailedSavePost />} />

          {/* Business section routes */}
          <Route
            path="/company/setup-page/new"
            element={<CreateLinkedInPage />}
          />
          <Route
            path="/company/setup-page/create-company-page"
            element={<CreateCompanyPage />}
          />
          <Route path="/company/dashboard" element={<CompanyDashboard />} />
          <Route path="/company/page-posts" element={<CompanyPagePosts />} />
          <Route path="/company/inbox" element={<CompanyInbox />} />
          <Route path="/company/product-listing" element={<CompanyProduct />} />
          <Route
            path="/company/product-description/car-wash-software"
            element={<CompanyProductDescription />}
          />
        </Route>

        {/* Catch-all route */}
        <Route path="*" element={<Error />} />
      </Routes>
    </>
  );
}

export default App;
